module.exports = __webpack_public_path__ + "img/test.cfc56ca3.png";